
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'DukesClassification',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DukesClassification.vue